export default {
  eyebrow: '02 - Innovation',
  component: 'm-article-section',
}
